import Select from "react-select";
import { useMultiSelectController } from "./MultiSelect.controller.ts";
import type MultiSelectProperties from "./MultiSelect.properties.ts";
import { useTranslation } from "react-i18next";

export default function MultiSelectView(props: MultiSelectProperties) {
  const { t } = useTranslation();
  const { selectedOptions, handleChange } = useMultiSelectController(props);

  return (
    <Select
      options={props.data}
      value={selectedOptions}
      onChange={handleChange}
      isSearchable
      isMulti
      menuPlacement="auto"
      noOptionsMessage={() => t("ui.noOptionsMessage")}
      placeholder={t("ui.select")}
      styles={{
        container: (base) => ({
          ...base,
          width: props.width ?? "170px",
          marginTop: props.marginTop ?? 0,
          marginBottom: props.marginBottom ?? 0,
        }),
        control: (base, state) => ({
          ...base,
          borderRadius: "10px",
          border: state.isFocused ? "1px solid #007bff" : "none",
          paddingLeft: "15px",
          fontSize: "16px",
        }),
        option: (base, state) => ({
          ...base,
          backgroundColor: state.isFocused
            ? "#eeeeee"
            : state.isSelected
              ? "#dddddd"
              : "#ffffff",
          color: "#252525",
        }),
      }}
    />
  );
}
